/**
 * CALL IT — the phone's bottom sheet (DESIGN-CHANGELOG 2026-09-03; `design/GT
 * Mobile Mine.dc.html:409-430`). AA phase 5.
 *
 * `CALL IT` + a 44px ✕; the strapline moves into the body under the game's
 * name; four 76px cells; the skip is a full-width 44px bordered control.
 */

import { Sheet } from '../components/Sheet.tsx';
import { useQd } from '../store/index.ts';
import { callItVM } from '../store/selectors.ts';

const MONO = 'var(--gt-font-mono)';
const PIXEL = 'var(--gt-font-pixel)';

export default function CallItSheet(): JSX.Element {
  const s = useQd();
  const v = callItVM(s);
  return (
    <Sheet onClose={() => s.closeAsk()} label="Call it now sheet" zIndex={85} header={{ title: 'CALL IT', titleClr: 'var(--gt-text)', titleFs: '9.5px' }}>
      <div style={{ padding: '14px 14px 4px', display: 'flex', flexDirection: 'column', gap: 5 }}>
        <span style={{ fontFamily: 'var(--gt-font-sans)', fontWeight: 600, fontSize: 15, color: 'var(--gt-text)' }}>{v.n}</span>
        <span style={{ fontFamily: MONO, fontSize: 8.5, letterSpacing: '.07em', color: 'var(--gt-faint)' }}>{v.strap}</span>
      </div>
      <div style={{ display: 'flex', padding: '10px 14px' }}>
        {v.cells.map((c, i) => (
          <div
            key={c.key}
            onClick={() => void s.askCall(c.l)}
            style={{
              flex: 1,
              height: 76,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 7,
              border: '1px solid ' + c.clr,
              color: c.clr,
              marginLeft: i ? -1 : 0,
              cursor: 'pointer',
              boxSizing: 'border-box',
            }}
          >
            <span style={{ fontFamily: PIXEL, fontSize: 14, transform: 'translateY(0.13em)' }}>{c.g}</span>
            <span style={{ fontFamily: MONO, fontSize: 7.5, letterSpacing: '.06em', textAlign: 'center', padding: '0 3px' }}>{c.t}</span>
          </div>
        ))}
      </div>
      <div style={{ padding: '4px 14px', paddingBottom: 'calc(14px + env(safe-area-inset-bottom))' }}>
        <div onClick={() => s.closeAsk()} style={{ height: 44, display: 'grid', placeItems: 'center', fontFamily: MONO, fontSize: 10, letterSpacing: '.07em', color: 'var(--gt-text-5)', border: '1px solid var(--gt-border-2)', cursor: 'pointer', boxSizing: 'border-box' }}>
          {v.skipL}
        </div>
      </div>
    </Sheet>
  );
}
